// Keep navigation spacing consistent across the main and role-specific sidebars.
export const sidebarItemClassName =
  "flex min-h-[48px] items-center rounded-lg p-2 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700 md:min-h-[56px]";

export const sidebarItemGroupClassName = "space-y-1 px-3";

export const sidebarSectionHeadingClassName =
  "px-2 pt-4 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400";

export const sidebarNavigationTheme = {
  item: {
    content: {
      base: "min-w-0 flex-1 whitespace-normal break-words px-3",
    },
  },
};
